/**
 * returns a promise that resolves when the document is fully loaded or is already fully loaded
 * @returns {Promise<void>}
 */
export function onLoad () {
  return new Promise((resolve) => {
    if (document.readyState === 'complete') {
      return resolve()
    }

    window.addEventListener('load', () => resolve())
  })
}
